export default "__VITE_ASSET__BPtRXUR1__"